import {
  GETVOUCHERREDEEMLIST_SUCCESS,
  GETVOUCHERREDEEMLIST_FAILED,
  RESET_GETVOUCHERREDEEMLIST,
  LOADING_GETVOUCHERREDEEMLIST,
  NETWORK_ERROR_GETVOUCHERREDEEMLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETVOUCHERREDEEMLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETVOUCHERREDEEMLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETVOUCHERREDEEMLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETVOUCHERREDEEMLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETVOUCHERREDEEMLIST:
      return (state = initialState);
    default:
      return state;
  }
};
